module.exports = __webpack_public_path__ + "img/base_bw.bb5762f2.png";